<script setup lang="ts">
// Trailing mark for a menu row that leaves the app (opens another site in a new tab). The icon is
// decorative, the hidden text is what a screen reader announces after the row's label.
</script>

<template>
  <span class="wad4-external-link-icon">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M14 4h6v6M20 4l-9 9M18 14v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="wad4-external-link-icon__text">(opens in a new tab)</span>
  </span>
</template>

<style lang="scss">
.wad4-external-link-icon {
  display: inline-flex;
  flex-shrink: 0;
  margin-left: auto;
  color: $wad4-c-foreground-fg-secondary;

  // The icon is a stroke drawing. The button-link classes paint every nested `svg path` with a fill,
  // hover included, which turned it into a solid blob inside the legal page's links.
  svg path {
    fill: none !important;
    stroke: currentColor !important;
  }

  &__text {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
  }
}
</style>
